export { WrapRootElementWithReduxProvider as wrapRootElement } from './src/state';
export { default as wrapPageElement } from './src/components/layouts/PageWrapper';
import './src/styles/global.css';

export const onClientEntry = () => {
    if (localStorage.getItem('hideScrollbar') === 'true') {
        document.documentElement.classList.add('scrollbar-hide');
    }
};
